import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import api from 'services/api';
import useAuthStore from 'stores/authStore';

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const setAuth = useAuthStore((s) => s.setAuth);
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use ref to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (sessionIdMatch) {
        const sessionId = sessionIdMatch[1];
        
        try {
          const response = await api.post('/auth/session', {
            session_id: sessionId
          });

          setAuth(response.data);
          
          // Check if this is a new user (needs role selection)
          // If coming from register page, go to role selection
          const fromRegister = document.referrer.includes('/register');
          
          if (fromRegister || !response.data.role || response.data.role === 'family_caregiver') {
            // Check if they have a care profile already
            try {
              const profilesRes = await api.get('/care-profiles');
              
              if (profilesRes.data.profiles && profilesRes.data.profiles.length > 0) {
                navigate('/dashboard', { replace: true });
              } else {
                navigate('/care-profile/setup', { replace: true });
              }
            } catch {
              navigate('/care-profile/setup', { replace: true });
            }
          } else {
            navigate('/dashboard', { replace: true });
          }
        } catch (error) {
          console.error('Auth callback error:', error);
          navigate('/login', { replace: true });
        }
      } else {
        navigate('/login', { replace: true });
      }
    };

    processAuth();
  }, [location.hash, navigate, setAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <div className="animate-pulse-soft mb-4">
          <div className="w-16 h-16 rounded-full bg-teal-500/20 flex items-center justify-center mx-auto">
            <div className="w-8 h-8 rounded-full bg-teal-500"></div>
          </div>
        </div>
        <p className="text-slate-600">Signing you in...</p>
      </div>
    </div>
  );
}
